import { Col, Container, Row } from 'react-bootstrap'
import './style.css'
import dayjs from 'dayjs'

export const DinneyFooter = () => {

    return (
        <footer className='bg-body-tertiary bg-custom-navbar p-3 mt-0'>
            <Container fluid>
                <Row >
                    <Col className="text-center text-color">{`Dinney Application ${dayjs().get('year')}. All rights reserved.`}</Col>
                </Row>
            </Container>
        </footer>
    )
}